// The signed-in account's three mailing lists, for the Subscriptions dialog (MailingList.vue,
// 2026-10-23): the lists chosen (publicMetadata.subscriptions), and a save of exactly those, as
// Profile → Settings' SUBSCRIPTIONS does (SettingsSubscribe.vue).

import {computed} from "vue";
import {getSubscribedTo} from "@/composables/subscriptionLists";
import {useSaveIsSubscribed} from "@/composables/useSaveIsSubscribed";
import useUserSafe from "@/composables/useUserSafe";

export const LIST_LABELS = {
  workshop: "Workshops",
  masterclass: "Masterclasses",
  showcase: "Showcases",
};

export function useAccountLists() {
  const {user} = useUserSafe();
  const {save} = useSaveIsSubscribed();
  const lists = computed(() => (user.value ? getSubscribedTo(user.value.publicMetadata) : null));
  async function persist(next) {
    const isSaved = await save(user.value, {subscriptions: next});
    return isSaved ? next : null;
  }
  return {lists, persist};
}
